export const SWIGGY_MONEY_OR_REWARDS_TOAST_MAX_COUNT = 3;

export const SPLITPAY_SOURCE = "splitpay";
